module.exports = __webpack_public_path__ + "img/icon_map_1_5.f034396c.png";